import { render, staticRenderFns } from "./AMForgotUserIDInfo.vue?vue&type=template&id=3401b967&scoped=true"
import script from "./AMForgotUserIDInfo.vue?vue&type=script&lang=js"
export * from "./AMForgotUserIDInfo.vue?vue&type=script&lang=js"
import style0 from "./AMForgotUserIDInfo.vue?vue&type=style&index=0&id=3401b967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401b967",
  null
  
)

export default component.exports